import { z } from 'zod';

export const orderStatusSchema = z.enum([
    'AwaitingPayment',
    'FailedPayment',
    'Paid',
    'Canceled',
    'BuyingItems',
    'ShippingToRussia',
    'ShippingByCdek',
    'Completed',
]);

export type OrderStatus = z.infer<typeof orderStatusSchema>;
